// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ImportOutlinedSvg from "@ant-design/icons-svg/es/asn/ImportOutlined";
import AntdIcon from '../components/AntdIcon';

var ImportOutlined = function ImportOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ImportOutlinedSvg
  }));
};

ImportOutlined.displayName = 'ImportOutlined';
export default React.forwardRef(ImportOutlined);